import { Chip } from "@material-ui/core";
import type { EpocusReferralStatus } from "../../../../global-providers/rxdb-provider/collections/epocus-referral";
import {
  EPOCUS_AMBER,
  EPOCUS_AMBER_BG,
  EPOCUS_BLUE,
  EPOCUS_BLUE_BG,
  EPOCUS_GREEN,
  EPOCUS_GREEN_BG,
  rem,
} from "../../_lib/epocus-palette";

const STATUS_CONFIG: Record<
  EpocusReferralStatus,
  { label: string; bg: string; color: string }
> = {
  sent: { label: "Sent", bg: EPOCUS_AMBER_BG, color: EPOCUS_AMBER },
  acknowledged: {
    label: "Acknowledged",
    bg: EPOCUS_BLUE_BG,
    color: EPOCUS_BLUE,
  },
  outcomeRecorded: {
    label: "Outcome Recorded",
    bg: EPOCUS_GREEN_BG,
    color: EPOCUS_GREEN,
  },
};

export const ReferralStatusChip: FC<{ status: EpocusReferralStatus }> = ({
  status,
}) => {
  const { label, bg, color } = STATUS_CONFIG[status];
  return (
    <Chip
      label={label}
      size="small"
      style={{
        backgroundColor: bg,
        color,
        fontWeight: 700,
        fontSize: rem(12),
      }}
    />
  );
};
